import { FC, useState } from 'react';
import { ButtonBase, Chip } from '@mui/material';
import { useGetSmartResponses } from './useGetSmartResponses';
import { Carousel } from '@vs-online-only-app/ui';
import { useSelectedHeroConversation } from '../../../hooks/useSelectedHeroConversation';
import {
  chatActions,
  useAppDispatch,
} from '@vs-online-only-app/state';
import useSendConversationMessages from '../../../hooks/useSendConversationMessages';

const SmartResponses: FC = () => {
  const [sentMessages, setSentMessages] = useState<string[]>([]);

  const dispatch = useAppDispatch();
  const selectedHeroConversation = useSelectedHeroConversation();
  const { sendMessages } = useSendConversationMessages(selectedHeroConversation);
  const isArchived = Boolean(selectedHeroConversation?.archiveAttributes);
  const { smartResponses } = useGetSmartResponses(!isArchived).data || {};

  const handleSendMessage = (message: string) => {
    if (!selectedHeroConversation) return;

    sendMessages({
      textMessageBody: message,
      files: [],
      sharedProducts: [],
    });
    setSentMessages([...sentMessages, message]);
  };

  if (!smartResponses || smartResponses.length === 0 || isArchived) {
    return null;
  }

  const unsentSmartResponses = smartResponses.filter(
    ({ smartResponse }) => !sentMessages.includes(smartResponse),
  );

  if (unsentSmartResponses.length === 0) {
    return null;
  }

  return (
    <Carousel>
      {unsentSmartResponses.map(({ smartResponse }) => (
        <ButtonBase
          style={{
            borderRadius: '100px',
          }}
          onClick={() => handleSendMessage(smartResponse)}
        >
          <Chip label={smartResponse} />
        </ButtonBase>
      ))}
    </Carousel>
  );
};

export default SmartResponses;
